import { Panel, Pill } from "@/admin/ui";

const TONE = { waiting: "orange", notified: "green" };

export const WaitlistPanel = ({ waitlist }) => (
  <Panel title={`Waitlist · ${waitlist.filter((w) => w.status === "waiting").length} waiting`} className="mt-6" testId="waitlist-panel">
    <p className="text-xs text-stone-500 mb-3">Customers who asked to be told on WhatsApp when you start delivering to their area. Exact pincodes are notified automatically when you add or switch on that pincode; use the bell on a pincode row for area names.</p>
    {waitlist.length === 0 && <p className="text-sm text-stone-500" data-testid="waitlist-empty">No one on the waitlist yet.</p>}
    <div className="divide-y divide-stone-100">
      {waitlist.map((w) => (
        <div key={w.id} className="flex flex-wrap items-center gap-x-3 gap-y-1 py-2 text-sm" data-testid={`waitlist-row-${w.id}`}>
          <span className="font-semibold">{w.name}</span>
          <span className="text-stone-500">+91 {w.phone}</span>
          <span className="text-xs bg-stone-100 rounded px-2 py-0.5">{w.query}</span>
          <span className="text-xs text-stone-500 mr-auto">{new Date(w.created_at).toLocaleDateString("en-IN")}</span>
          <Pill tone={TONE[w.status]}>{w.status === "notified" ? `Notified · ${w.notified_pincode}` : "Waiting"}</Pill>
          {w.status === "waiting" && w.last_attempt && <span className="w-full text-xs text-accent">Last try: {w.last_attempt.status}{w.last_attempt.error ? ` – ${w.last_attempt.error}` : ""}</span>}
        </div>
      ))}
    </div>
  </Panel>
);
